import { SystemUsageData } from "../../../../../types"
import { numberToUSD } from "../../../../utils"
import Cell from "../../../billing-table/cell"
import HeaderCell from "../../../billing-table/header-cell"
import HeaderRow from "../../../billing-table/header-row"
import If from "../../../if"
import TableFooter from "../table-footer"
import TableWrapper from "../table-wrapper"

interface Props {
  usage: SystemUsageData
}

const EmailBreakdown = ({ usage }: Props) => (
  <>
    <div>
      <strong>Total Emails:</strong> {usage?.breakdown?.emails?.total} (
      {usage?.pricing_details.included_emails} included)
    </div>
    <If
      condition={
        !!usage?.breakdown?.cost?.breakdown?.emails?.breakdown[0]?.subtotal
      }
      then={
        <TableWrapper>
          <thead>
            <HeaderRow>
              <HeaderCell>LINE ITEM</HeaderCell>
              <HeaderCell className="text-center">RATE</HeaderCell>
              <HeaderCell className="text-center">COUNT</HeaderCell>
              <HeaderCell className="text-right">LINE TOTAL</HeaderCell>
            </HeaderRow>
          </thead>

          <tbody className="divide-y divide-zinc-200">
            {usage?.breakdown?.cost?.breakdown?.emails?.breakdown?.map(
              (item, key) => (
                <tr key={key}>
                  <Cell>
                    <span>Tier {key + 1} Emails</span>
                    <br />
                    <small>
                      Email count {item.start}{" "}
                      {item.stop ? `- ${item.stop}` : "+"}
                    </small>
                  </Cell>
                  <Cell className="text-center">{numberToUSD(item.cpe)}</Cell>
                  <Cell className="text-center">
                    {Math.round((item?.subtotal ?? 0) / item.cpe)}
                  </Cell>
                  <Cell className="text-right">
                    {numberToUSD(item.subtotal)}
                  </Cell>
                </tr>
              )
            )}
          </tbody>
          <TableFooter
            subTotal={usage?.breakdown?.cost?.breakdown?.emails?.total}
          />
        </TableWrapper>
      }
      else={
        <TableWrapper>
          <TableFooter
            subTotal={usage?.breakdown?.cost?.breakdown?.emails?.total}
          />
        </TableWrapper>
      }
    />
  </>
)

export default EmailBreakdown
